import $$ from "Dom7";
import actions from "../js/actions.js"; // Import Routes

import URLS from "../js/Urls.js";
var today = new Date();
var myDate = today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
var GotomainPage = false;
export default {
  on: {
    pageInit: () => {
      // localStorage.clear();
      // app.f7.views.main.router.url == "/login/";
      // app.f7.views.main.router.navigate("/login/", { reloadCurrent: true });
      var WrongCredentials = app.f7.toast.create({
        text: "Wrong Username or Password",
        position: "center",
        closeTimeout: 2000
      });
      var toastCheckConnection = app.f7.toast.create({
        text: "Check your internet connection",
        position: "center",
        closeTimeout: 1500
      });
      $$(".toolbar.toolbar-bottom").css("display", "none");
      $$(".pass-toggle").on("click", async () => {
        if ($$(".vis").hasClass("no-show")) {
          $$(".vis").removeClass("no-show");
          $$(".novis").addClass("no-show");
          $("#PswLogin").attr('type', 'password');
        } else {
          $$(".novis").removeClass("no-show");
          $$(".vis").addClass("no-show");
          $("#PswLogin").attr('type', 'text');
        }
      });
      $$("#login-button").on("click", async () => {
        var username = $$("#EmailLogin").val();
        var password = $$("#PswLogin").val(); // if(username == "" && password == ""){
        //   return;
        // }
        //Check pass
        // if(username === "test" && password ==="test"){
        //     //mainView.router.navigate('/pmshome/');
        //     localStorage.setItem("islogin",1);
        //     ;
        //     // Framework7.instance.views.main.router.load('/dashboard/');
        //     Framework7.instance.views.main.router.navigate('/dashboard/', {reloadCurrent: true});
        //     // app.views.main.router.navigate('/pmshome/', {reloadCurrent: true});
        // }else{
        //   toastCenter.open();
        // }

        var User = {
          Username: username,
          Password: password
        };
        app.f7.preloader.show(); // wait for 3 seconds
        // await new Promise(resolve => setTimeout(resolve, 3000));

        let result; // await app.f7.request.promise.get('https://jsonplaceholder.typicode.com/todos/1', {})
        //   .then((data) => {
        //     ;
        //     actions.SetResult(data.data);
        //   });

        try {
          var GotomainPage = false;
          await app.f7.request.promise.post(URLS.login, {
            User
          }).then(res => {
            var LoginResponse = JSON.parse(res.data);
            result = JSON.parse(res.data);

            if (LoginResponse.SuccessLogin === true) {
              localStorage.setItem("islogin", 1);
              actions.LoginSetResult(LoginResponse);
              GotomainPage = true;
            } else {
              app.f7.preloader.hide();
              WrongCredentials.open();
            }
          });
        } catch (err) {
          console.log(err);
          app.f7.preloader.hide();
          toastCheckConnection.open();
        }

        if (GotomainPage == true) {
          var obj = actions.LoginGetResult();
          var id = obj.PropertyID;
          var obj = {
            PropertyID: id,
            Date: myDate,
            UserID: obj.UserID
          };

          try {
            console.log(obj.UserID);
            window.plugins.OneSignal.User.addTags({
              UserID: obj.UserID
            });
            window.plugins.OneSignal.login(obj.UserID);
          } catch (e) {}

          await app.f7.request.promise.post(URLS.dashboardinfo, {
            obj
          }).then(res => {
            var DashboardinfoResponse = JSON.parse(res.data);
            actions.SetDashboardInfo(DashboardinfoResponse);
            localStorage.removeItem("f7router-view_main-history");

            if (result.IsHousekeeper === true) {
              app.f7.views.main.router.navigate("/dashboardKeeper/", {
                transition: "f7-dive"
              });
            } else {
              app.f7.views.main.router.navigate("/main/", {
                transition: "f7-dive"
              });
            }
          });
        }
      });

      if (localStorage.getItem("showexitmessage") == 1) {
        if (app.f7.views.main.router.url == "/login/") {
          localStorage.removeItem("f7router-view_main-history");
          var exitappdialog = app.f7.dialog.create({
            title: "",
            text: "Are you sure want to exit the app?",
            buttons: [{
              text: "Cancel",
              cssClass: "dialogcancelbtn",
              onClick: function () {
                console.log("declined");
              }
            }, {
              text: "Exit",
              cssClass: "logoutbtn",
              onClick: function () {
                console.log("LogOut"); // app.f7.views.main.router.navigate("/login/", {
                //   transition: "f7-dive",
                // });

                localStorage.removeItem("showexitmessage");
                window.navigator.app.exitApp();
              }
            }]
          }); // exitappdialog.open();
        } // localStorage.removeItem("f7router-view_main-history");
        // return;
        //redirect to another view
        // var view=app.views.current;
        // view.router.back(view.history[0], { force: true });
        // localStorage.removeItem("f7router-view_main-history");
        // setTimeout(function () {
        //   app.f7.views.main.router.navigate("/main/", {
        //     transition: "f7-dive",
        //   });
        // }, 2000);

      }
    }
  },
  id: 'b4dbf0d52b',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '<div class=page data-name=login><div class="page-content login" style="padding: unset"><div class=login-logo></div><span class=Roomrack-title>ROOMRACK </span><span class=room-sub>CLOUD HOTEL PMS</span><div class=login-text><span><b>Hello there,</b></span><br><span>Hope you have a good day<br>taking care of all your quests.</span></div><div action="" id=my-login-screen><div class=container><div class="row square"><div class=col-10><i class=material-icons style="margin-top: 8px">mail_outline</i></div><div class=col-90><input type=text id=EmailLogin placeholder="Email ID here" name=email autocomplete=off style="border-bottom: 0px; padding: 9px 3px" required></div></div><div class="row square"><div class=col-10><i class=material-icons style="margin-top: 8px">lock</i></div><div class=col-80><input type=password id=PswLogin placeholder="Enter Password here" name=psw style="border-bottom: 0px; padding: 9px 3px" required></div><div class="col-10 pass-toggle"><i class="material-icons vis">visibility</i> <i class="material-icons novis no-show">visibility_off</i></div></div><div class=row><span class=psw style="width: 47%; text-align: end; margin-top: 10px"><a id=frgpsw href=/forgot-password/ >Forgot password?</a></span> <button type=submit id=login-button style="background-color: #0b8cb1">LOGIN</button></div></div></div><div class=footer><div class=row style="color: #353636; font-size: 12px"><span>Please reach out to us for any help</span></div><div class=row><div class=col-50 style="display: inline-flex; padding: 5px"><div class=col><i class=material-icons>phone</i></div><div class=col>+30 210 3000 921</div><!-- <i class="material-icons">\n              phone\n            </i>\n            <p>+30 210 3000 921 </p> --></div><div class=col-50 style="display: inline-flex; padding: 5px"><div class=col><i class=material-icons>email</i></div><div class=col>info@abouthotelier.com</div><!-- <i class="material-icons">\n              email\n            </i>\n            <p>info@abouthotelier.com </p> --></div></div></div></div></div>';
      return r;
    }(this);
  },

  style: `
  .pass-toggle {
    padding: 8px;
    border-left: 1px solid black;
    width: 38px !important;
    border-radius: 5px;
    display: flex;
    align-items: center;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  .no-show {
    display: none;
  }
`,
  styleScoped: false
};